// src/components/PhotoCard.jsx
import React from 'react';
import { Film, Camera, Trash2, Calendar } from 'lucide-react';

const PhotoCard = ({ photo, onClick, isAdmin, onDelete }) => {
    const isVideo = photo.type === 'video';
    const TypeIcon = isVideo ? Film : Camera;

    return (
        <div
            className="group relative aspect-square cursor-pointer overflow-hidden rounded-2xl bg-gray-100
                      ring-1 ring-black/5 shadow-sm transition-all duration-300
                      hover:-translate-y-1 hover:shadow-xl hover:ring-purple-200"
            onClick={() => onClick(photo)}
        >
            {isVideo ? (
                <video
                    src={photo.fileUrl}
                    className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
                    muted
                    preload="metadata"
                />
            ) : (
                <img
                    src={photo.fileUrl}
                    alt={photo.title}
                    className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
                />
            )}

            {/* Media-type chip */}
            <span className="absolute left-3 top-3 grid h-8 w-8 place-items-center rounded-full bg-black/45 backdrop-blur-sm">
                <TypeIcon className="h-4 w-4 text-white" />
            </span>

            {/* Admin delete */}
            {isAdmin && (
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onDelete(photo.$id, photo.imageId);
                    }}
                    aria-label="Delete media"
                    className="absolute right-3 top-3 z-10 grid h-8 w-8 place-items-center rounded-full
                             bg-black/45 text-white opacity-0 backdrop-blur-sm transition-all
                             hover:bg-red-500 group-hover:opacity-100"
                >
                    <Trash2 className="h-4 w-4" />
                </button>
            )}

            {/* Persistent base gradient + caption reveal */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 translate-y-2 p-4 opacity-0 transition-all duration-300
                          group-hover:translate-y-0 group-hover:opacity-100">
                <h3 className="truncate font-display text-base font-semibold text-white">
                    {photo.title}
                </h3>
                <div className="mt-1 flex items-center gap-3 text-xs text-white/80">
                    {photo.date && (
                        <span className="flex items-center gap-1.5">
                            <Calendar className="h-3.5 w-3.5" />
                            {photo.date}
                        </span>
                    )}
                    {photo.category && (
                        <span className="rounded-full bg-white/20 px-2 py-0.5 font-medium backdrop-blur-sm">
                            {photo.category}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PhotoCard;
